// themeSlice.js
import { createSlice } from "@reduxjs/toolkit";

const getInitialTheme = () => {
  const savedTheme = localStorage.getItem("theme");
  return savedTheme ? savedTheme : "light"; // Default to 'light' if no theme is saved
};

const themeSlice = createSlice({
  name: "theme",
  initialState: {
    currentTheme: getInitialTheme(), // Set the initial theme to 'light'
  },
  reducers: {
    toggleTheme: (state) => {
      state.currentTheme = state.currentTheme === "light" ? "dark" : "light";
      localStorage.setItem("theme", state.currentTheme); // Save the theme to localStorage
    },
  },
});

export const { toggleTheme } = themeSlice.actions;

export default themeSlice.reducer;
